<template>
  <main class="paymentsContainer px-4 px-sm-10">
    <v-progress-circular
      v-if="isLoading"
      width="3"
      size="50"
      indeterminate
      color="#FFA903"
    />
    <div v-else-if="payments.length > 0" class="paymentsWrapper">
      <div class="paymentsTimeline">
        <div v-for="(payment, index) in payments" :key="payment.id">
          <TimelineItem
            :value="`Платеж номер ${index + 1} `"
            :subtitle="`Сумма ${payment.amount} AMD`"
            :status="payment.state"
          />
          <TimelineDivider v-if="index !== payments.length - 1" />
        </div>
        <div class="paymentsButtonMobile">
          <p>Нажмите на кнопку, чтобы произвести следующую оплату.</p>
          <v-btn
            @click="onPayHandler"
            :loading="isPaymentLoading"
            class="main-btn"
          >
            Оплатить
          </v-btn>
        </div>
      </div>
      <div class="paymentsContent">
        <p>
          На данный момент имеются ограничения для платежной системы «Мир».
          Оплата была разделена на несколько платежей! Общая сумма платежа
          составляет <span class="textActive">{{ paymentsSum }} AMD</span>.
        </p>
        <div class="paymentsButton">
          <p>Нажмите на кнопку, чтобы произвести следующую оплату.</p>
          <v-btn
            @click="onPayHandler"
            :loading="isPaymentLoading"
            class="main-btn"
          >
            Оплатить
          </v-btn>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { fetchPaymentLink, fetchRegistrationStatus } from "@/api/registration";
import TimelineItem, {
  StatusTypes
} from "@/components/timeline-item/TimelineItem";
import TimelineDivider from "@/components/timeline-item/TimelineDivider";

export default {
  name: "RegistrationPayments",
  components: { TimelineDivider, TimelineItem },
  computed: {
    sessionId() {
      return this.$route.query.sessionId;
    },
    registrationId() {
      return this.$route.query.registrationId;
    },
    paymentsSum() {
      return this.payments.reduce(
        (previous, current) => (current?.amount ?? 0) + previous,
        0
      );
    }
  },
  mounted() {
    this.getRegistrationStatusStatus();
  },
  data: () => ({
    isLoading: false,
    payments: [],
    isPaymentLoading: false
  }),
  methods: {
    async getRegistrationStatusStatus() {
      this.isLoading = true;
      try {
        const response = await fetchRegistrationStatus(
          this.sessionId,
          this.registrationId
        );
        if (response?.status) {
          await this.$router.push(
            `/registration-confirmation?sessionId=${this.sessionId}&registrationId=${this.registrationId}`
          );
        }

        this.payments = response?.payments ?? [];
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async onPayHandler() {
      this.isPaymentLoading = true;
      try {
        const currentPayment = this.payments.find(
          payment => payment.state !== StatusTypes.PAID
        );
        if (!currentPayment) {
          return;
        }
        const response = await fetchPaymentLink(
          currentPayment.id,
          this.registrationId
        );
        if ("redirectUrl" in response) {
          window.location.href = response.redirectUrl;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isPaymentLoading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/vars";

.paymentsContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
}

.paymentsWrapper {
  display: flex;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
}

.paymentsContent {
  max-width: 350px;

  @media (max-width: 768px) {
    max-width: 100%;
    margin-bottom: 32px;
  }
}

.paymentsButton {
  @media (max-width: 768px) {
    display: none;
  }
}

.paymentsButtonMobile {
  display: none;

  @media (max-width: 768px) {
    display: block;
    margin-top: 100px;
  }
}

.textActive {
  font-weight: 500;
  color: $activeColor;
}
</style>
